exports.isatty = function () {};
exports.setRawMode = function () {};



//////////////////
// WEBPACK FOOTER
// ./~/node-libs-browser/mock/tty.js
// module id = 652
// module chunks = 0